/**
 * Referral Code Tracking
 *
 * Captures referral codes from URL parameters (?ref=CODE)
 * and persists them via cookie (90 days) + localStorage backup.
 */

import { getCookie, setCookie } from './deviceFingerprint'

const REFERRAL_COOKIE = 'silux_referral_code'
const REFERRAL_STORAGE_KEY = 'silux_referral'

/**
 * Called on app load to capture ?ref=CODE from URL
 */
export function captureReferralFromUrl(): string | null {
  const params = new URLSearchParams(window.location.search)
  const refCode = params.get('ref')
  if (refCode) {
    setCookie(REFERRAL_COOKIE, refCode, 90)
    localStorage.setItem(
      REFERRAL_STORAGE_KEY,
      JSON.stringify({ code: refCode, capturedAt: new Date().toISOString() })
    )
    // Clean URL without reload
    const url = new URL(window.location.href)
    url.searchParams.delete('ref')
    window.history.replaceState({}, '', url.toString())
  }
  return refCode
}

/**
 * Get stored referral code (cookie first, localStorage fallback)
 */
export function getStoredReferralCode(): string | null {
  const fromCookie = getCookie(REFERRAL_COOKIE)
  if (fromCookie) return fromCookie

  try {
    const stored = localStorage.getItem(REFERRAL_STORAGE_KEY)
    if (stored) {
      const parsed = JSON.parse(stored)
      return parsed?.code || null
    }
  } catch {
    // ignore parse errors
  }
  return null
}

/**
 * Clear referral code after successful order
 */
export function clearReferralCode(): void {
  setCookie(REFERRAL_COOKIE, '', -1)
  localStorage.removeItem(REFERRAL_STORAGE_KEY)
}
